var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChatbot(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 68,
    viewBox: "0 0 66 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1423_34954)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32 8.66318C33.1825 8.10145 34 6.8962 34 5.5C34 3.567 32.433 2 30.5 2C28.567 2 27 3.567 27 5.5C27 6.8962 27.8175 8.10145 29 8.66318V12.0788C19.4108 12.8379 11.3444 19.0076 7.85375 27.5353C7.07692 27.3015 6.19737 27.3766 5.41 27.8687L3.41 29.1187C2.53286 29.667 2 30.6284 2 31.6627V38.3373C2 39.3716 2.53286 40.333 3.41 40.8813L5.41 42.1313C5.79945 42.3747 6.21146 42.516 6.62243 42.5685C9.15348 53.6953 19.1069 62 31 62C42.8931 62 52.8465 53.6953 55.3776 42.5685C55.7885 42.516 56.2005 42.3747 56.59 42.1313L58.59 40.8813C59.4671 40.333 60 39.3716 60 38.3373V31.6627C60 30.6284 59.4671 29.667 58.59 29.1187L56.59 27.8687C55.8026 27.3766 54.9231 27.3015 54.1463 27.5353C50.5349 18.7128 42.0259 12.414 32 12.0196V8.66318Z",
    fill: "#25569D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 37C13 27.0589 21.0589 19 31 19C40.9411 19 49 27.0589 49 37C49 46.9411 40.9411 55 31 55C21.0589 55 13 46.9411 13 37Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0798 45C21.7702 45 21.46 44.887 21.2174 44.6587C20.7163 44.1871 20.6965 43.4019 21.1725 42.9054C24.1726 39.7788 24.1726 34.8811 21.1725 31.7545C20.6965 31.2581 20.7163 30.4734 21.2174 30.0012C21.7184 29.529 22.5105 29.5492 22.9871 30.0456C26.9072 34.1304 26.9072 40.5295 22.9871 44.6137C22.7409 44.8703 22.411 44.9995 22.0798 44.9995V45Z",
    fill: "#25569D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.7224 45.0001C38.3912 45.0001 38.0613 44.8709 37.8151 44.6143C33.895 40.5295 33.895 34.1305 37.8151 30.0456C38.2911 29.5492 39.0838 29.5296 39.5849 30.0012C40.0859 30.4729 40.1057 31.2581 39.6297 31.7545C36.629 34.8811 36.629 39.7789 39.6297 42.9055C40.1057 43.4019 40.0859 44.1865 39.5849 44.6587C39.3428 44.8871 39.0326 45.0001 38.7224 45.0001Z",
    fill: "#25569D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4535 37.3959C27.6036 37.3959 25.3438 36.519 23.9378 35.7735C23.2895 35.4299 23.045 34.6302 23.3925 33.988C23.7393 33.3457 24.5465 33.1036 25.1948 33.4477C26.3564 34.0641 28.2391 34.7905 30.6158 34.7571C32.8075 34.7254 34.5499 34.0525 35.6265 33.4933C36.2778 33.1549 37.0826 33.4039 37.4242 34.0491C37.7659 34.6942 37.5144 35.4916 36.8632 35.83C34.952 36.8228 32.8046 37.3642 30.6548 37.3954C30.5879 37.3965 30.521 37.3971 30.4546 37.3971L30.4535 37.3959Z",
    fill: "#25569D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6288 30.9461C28.235 30.9461 28.7264 30.2866 28.7264 29.4731C28.7264 28.6595 28.235 28 27.6288 28C27.0227 28 26.5312 28.6595 26.5312 29.4731C26.5312 30.2866 27.0227 30.9461 27.6288 30.9461Z",
    fill: "#25569D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.1835 30.9461C33.7897 30.9461 34.2811 30.2866 34.2811 29.4731C34.2811 28.6595 33.7897 28 33.1835 28C32.5773 28 32.0859 28.6595 32.0859 29.4731C32.0859 30.2866 32.5773 30.9461 33.1835 30.9461Z",
    fill: "#25569D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1423_34954",
    x: 0,
    y: 0,
    width: 66,
    height: 68,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1423_34954"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1423_34954",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatbot);
export default __webpack_public_path__ + "static/media/Chatbot.a12094f7876bbbe4d869e701a0b3f668.svg";
export { ForwardRef as ReactComponent };